import { useCallback } from "react";
import ReportService from "../../../../../../../../../services/reportGeneration";
import { useDownloadReport } from "../../../../../../../../../lib/hooks/useDownloadReport";
import { useOpenProgressModal } from "../../../../../../../../../lib/hooks/useOpenProgressModal";
import { SUCCESS_PDF_DOWNLOAD } from "../../../../../../../../../lib/constants";

export const usePrintHistory = (
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>,
  close?: () => void,
) => {
  const { download } = useDownloadReport(setIsLoading);

  const { openModal } = useOpenProgressModal(
    "Generating History Report",
    "Generating History Report failed",
    (id?: string) => {
      download(ReportService, id);
    },
    {
      customMsg: SUCCESS_PDF_DOWNLOAD,
    },
  );

  const printHistory = useCallback(
    async (request: any) => {
      try {
        setIsLoading(true);

        const id: string = await ReportService.generateReportByName(
          "PaymentHistoryReport",
          request,
        );

        openModal(id);

        setIsLoading(false);

        close && close();
      } catch {
        setIsLoading(false);
      }
    },
    [setIsLoading, openModal, close],
  );

  return { printHistory };
};
